import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.paymentCard;
const getDataCreate = (state: AppState) => state.paymentCard.dataCreate;
const getHasCreated = (state: AppState) => state.paymentCard.isCreated;
const getResponseCreated = (state: AppState) => state.paymentCard.responseCreate;
const getResponseConfirm = (state: AppState) => state.paymentCard.responseConfirm;
const getResponseAuth = (state: AppState) => state.paymentCard.responseAuth;
const getHasConfirm = (state: AppState) => state.paymentCard.isConfirm;
const getHasAuthorization = (state: AppState) => state.paymentCard.isAuthorization;

export const getPaymentCardStoreSelector = createSelector(getStore, (data) => data);

export const getPaymentCardDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getPaymentCardHasCreatedSelector = createSelector(getHasCreated, (status) => status);
export const getPaymentCardResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getPaymentCardHasConfirmSelector = createSelector(getHasConfirm, (status) => status);
export const getPaymentCardResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getPaymentCardHasAuthorizationSelector = createSelector(getHasAuthorization, (status) => status);
export const getPaymentCardResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
